const Loader = () => {
  const square: React.CSSProperties = {
    display: "inline-block",
    background: "#1a2f4e",
    border: "none",
    borderRadius: "2px",
    width: "26px",
    height: "26px",
    position: "absolute",
    padding: 0,
    margin: 0,
  };

  return (
    <>
      <style>{`
        .loadingspinner {
          width: calc(3 * 30px + 26px);
          height: calc(2 * 30px + 26px);
          margin: 10px auto 30px;
          position: relative;
        }
        .loadingspinner #square1 {
          left: 0px; top: 0px;
          animation: square1 2.4s 0.2s ease-in-out infinite,
                     squarefadein 0.4s 0.1s ease-out both;
        }
        .loadingspinner #square2 {
          left: 0px; top: 30px;
          animation: square2 2.4s 0.2s ease-in-out infinite,
                     squarefadein 0.4s 0.1s ease-out both;
        }
        .loadingspinner #square3 {
          left: 30px; top: 30px;
          animation: square3 2.4s 0.2s ease-in-out infinite,
                     squarefadein 0.4s 0.2s ease-out both;
        }
        .loadingspinner #square4 {
          left: 60px; top: 30px;
          animation: square4 2.4s 0.2s ease-in-out infinite,
                     squarefadein 0.4s 0.3s ease-out both;
        }
        .loadingspinner #square5 {
          left: 90px; top: 30px;
          animation: square5 2.4s 0.2s ease-in-out infinite,
                     squarefadein 0.4s 0.4s ease-out both;
        }
        @keyframes square1 {
          0%     { left: 0px;  top: 0px;  }
          8.333% { left: 0px;  top: 30px; }
          100%   { left: 0px;  top: 30px; }
        }
        @keyframes square2 {
          0%     { left: 0px;  top: 30px; }
          8.333% { left: 0px;  top: 60px; }
          16.67% { left: 30px; top: 60px; }
          25.00% { left: 30px; top: 30px; }
          83.33% { left: 30px; top: 30px; }
          91.67% { left: 30px; top: 0px;  }
          100%   { left: 0px;  top: 0px;  }
        }
        @keyframes square3 {
          0%,100% { left: 30px; top: 30px; }
          16.67%  { left: 30px; top: 30px; }
          25.00%  { left: 30px; top: 0px;  }
          33.33%  { left: 60px; top: 0px;  }
          41.67%  { left: 60px; top: 30px; }
          66.67%  { left: 60px; top: 30px; }
          75.00%  { left: 60px; top: 60px; }
          83.33%  { left: 30px; top: 60px; }
          91.67%  { left: 30px; top: 30px; }
        }
        @keyframes square4 {
          0%     { left: 60px; top: 30px; }
          33.33% { left: 60px; top: 30px; }
          41.67% { left: 60px; top: 60px; }
          50.00% { left: 90px; top: 60px; }
          58.33% { left: 90px; top: 30px; }
          100%   { left: 90px; top: 30px; }
        }
        @keyframes square5 {
          0%     { left: 90px; top: 30px; }
          50.00% { left: 90px; top: 30px; }
          58.33% { left: 90px; top: 0px;  }
          66.67% { left: 60px; top: 0px;  }
          75.00% { left: 60px; top: 30px; }
          100%   { left: 60px; top: 30px; }
        }
        @keyframes squarefadein {
          0%   { transform: scale(0.75); opacity: 0; }
          100% { transform: scale(1.0);  opacity: 1; }
        }
      `}</style>
      <div className="loadingspinner">
        <div id="square1" style={square} />
        <div id="square2" style={square} />
        <div id="square3" style={square} />
        <div id="square4" style={square} />
        <div id="square5" style={square} />
      </div>
    </>
  );
};

export default Loader;
